import { render, staticRenderFns } from "./RiskOverallBanner.vue?vue&type=template&id=6c5555d2&scoped=true"
import script from "./RiskOverallBanner.vue?vue&type=script&lang=js"
export * from "./RiskOverallBanner.vue?vue&type=script&lang=js"
import style0 from "./RiskOverallBanner.vue?vue&type=style&index=0&id=6c5555d2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5555d2",
  null
  
)

export default component.exports